import { ApplicationInfo } from "./applicationInfoTypes";
import axios from "axios";

export const fetchApplicationInfo = async (): Promise<ApplicationInfo> => {
  const result = await axios.get("/application-info.json", {
    validateStatus: (status) => status === 200,
  });

  return result.data;
};